import { render, staticRenderFns } from "./MostRecognized.vue?vue&type=template&id=78f1212e"
import script from "./MostRecognized.vue?vue&type=script&lang=js"
export * from "./MostRecognized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports